import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {Service} from '../models/service';
import {LoadServicesSuccessAction, servicesActionTypes} from '../actions/service';

export interface ServicesState {
  array: Service[];
}

const initialState: ServicesState = {
  array: []
};

export function servicesReducer(state: ServicesState = initialState, action: Action): ServicesState {
  switch (action.type) {
    case servicesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case servicesActionTypes.LOAD_FAIL:
      return handleLoadFailAction(state);
    case servicesActionTypes.CLEAR:
      return handleLoadClearAction(state);
    default:
      return state;
  }
}

function handleLoadSuccessAction(state: ServicesState, action: LoadServicesSuccessAction): ServicesState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}



function handleLoadFailAction(state: ServicesState): ServicesState {
  const newState = _.clone(state);
  newState.array = [];
  return newState;
}
function handleLoadClearAction(state: ServicesState): ServicesState {
  return initialState;
}

export const servicesSelectors = {
  array: (state: ServicesState) => _.get(state, 'array', [])
};
